module.exports = __webpack_public_path__ + "static/media/tarot-card-0.0956bce7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/tarotcards/tarot-card-0.jpg
// module id = 1541
// module chunks = 0